import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { Box } from "@mui/material";

import * as BotpressSessionActions from "../../state/redux/botpressSession";
import { deepCopyObject } from "../../utils/helpers.js";
import BotpressPresentedLinksTable from "../ui/botpressPresentedLinksTable.js";
import Widget from "../ui/widget.js";
import WidgetSkeleton from "../ui/widgetSkeleton.js";
import WidgetSurveyContent from "../ui/widgetSurveyContent.js";
import WidgetTitle from "../ui/widgetTitle.js";

const BotpressPresentedLinks = ({
  presentedLinks,
  presentedLinkPagination,
  presentedLinkPageLoading,
  searchPresentedLinksRequest,
  widgetSize = "medium",
  minHeight = "333px",
}) => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (presentedLinks != null) {
      setRows(presentedLinks);
    } else {
      setRows([]);
    }
  }, [presentedLinks]);

  const onRequestNewPage = async pagination => {
    try {
      searchPresentedLinksRequest(pagination);
    } catch (error) {
      console.error("Error getting presented links table rows", error);
      setRows([]);
    }
  };

  const onRefreshTable = () => {
    let newPagination = deepCopyObject(presentedLinkPagination || {});
    newPagination["invalidateCache"] = true;
    onRequestNewPage(newPagination);
  };

  return (
    <Widget
      widgetSize={widgetSize}
      minHeight={minHeight}
      sx={{
        height: "100%",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          height: "100%",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <WidgetTitle
          title={"Navigation"}
          text={rows != null ? `${rows.length} Presented Links` : "Presented Links"}
        />

        {rows == null && <WidgetSkeleton />}

        {rows != null && (
          <WidgetSurveyContent>
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                boxSizing: "border-box",
                opacity: presentedLinkPageLoading ? 0.45 : 1,
                pointerEvents: presentedLinkPageLoading ? "none" : "auto",
                transition: "opacity 0.25s ease",
              }}
            >
              <BotpressPresentedLinksTable
                data={rows}
                onRequestNewPage={onRequestNewPage}
                dataReduxPagination={presentedLinkPagination}
                onRefreshTable={onRefreshTable}
              />
            </Box>
          </WidgetSurveyContent>
        )}
      </Box>
    </Widget>
  );
};

const mapStateToProps = state => ({
  presentedLinks: state.botpressSession.presentedLinks,
  presentedLinkPagination: state.botpressSession.presentedLinkPagination,
  presentedLinkPageLoading: state.botpressSession.presentedLinkPageLoading,
});

const mapDispatchToProps = {
  searchPresentedLinksRequest: BotpressSessionActions.searchPresentedLinksRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(BotpressPresentedLinks);
